module.exports = __webpack_public_path__ + "eb64f7e0ed8935de33bbcd1e4cba779f.fbx";